import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { partial, isEmpty } from 'lodash';
import React, { useContext } from 'react';

import Person from './Person';
import Context from '../Context';

const Container = styled.div``;

export default function People({ people, select, deselect, isSelected }) {
  const { focusKey } = useContext(Context);

  if (isEmpty(people)) {
    return null;
  }

  return (
    <Container>
      <h5>People</h5>
      {people.map((person) => {
        const selected = isSelected(person.id);
        const onClick = selected ? deselect : select;

        return (
          <Person
            key={person.id}
            focused={focusKey === `person_${person.id}`}
            selected={selected}
            onClick={partial(onClick, person.id, person.name, person)}
            {...person}
          />
        );
      })}
    </Container>
  );
}

People.propTypes = {
  people: PropTypes.object,
  isSelected: PropTypes.func.isRequired,
  select: PropTypes.func.isRequired,
  deselect: PropTypes.func.isRequired,
};
